import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { IconRegistry } from '@tylertech/forge';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';

import { AppModule } from './app/app.module';
import { ForgeIcons } from './app/forge-components';

IconRegistry.define(ForgeIcons);

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic(providers).bootstrapModule(AppModule);
if (environment.hmr) {
  if ((<any>module)['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
}
bootstrap();

